/**
 * A simple component which renders small "show more" button.
 */

import React from "react";
import styled from "styled-components";

const Button = ({ onClick, children, className }) => {
  return (
    <ButtonElem type="button" className={className} onClick={onClick}>
      {children}
    </ButtonElem>
  );
};

export const ButtonElem = styled.button`
  font-size: 14px;
  text-align: center;
  color: #2f80ed;
  background: rgba(${(props) => props.theme.brandColorRGB}, 0.1);
  border: 0;
  border-radius: 4px;
  padding: 8px 18px;
  cursor: pointer;
  transition: all 0.2s ease-out;

  &:hover {
    background: rgba(${(props) => props.theme.brandColorRGB}, 0.2);
  }

  &.marged {
    // Let's imagine there is a word like that:D There is "padded" though, but it's different.
    margin-top: 3px;
    margin-left: 15px;
  }

  &.small {
    padding: 3px 8px;
  }

  &.right {
    position: absolute;
    right: 15px;
    bottom: 0;
  }

  &.call-us {
    background-color: transparent;
    border: 2px solid #f2f2f2;
    color: #9c9ba8;
    padding: 6px 18px;

    svg {
      position: relative;
      top: 2px;
    }

    svg path {
      transition: all 0.2s ease-out;
    }

    &:hover {
      color: ${(props) => props.theme.brandColor};
      border-color: rgba(${(props) => props.theme.brandColorRGB}, 0.3);

      svg path {
        fill: ${(props) => props.theme.brandColor};
      }
    }
  }
`;

export default Button;
